<template>
  <material-card
    :title="`${ $t('Deliveries') }`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md2>
            <MaglinkComponentTankList
              :loading="progessBar.loading"
              :filters="filters"
              :tanks="tanks" />
          </v-flex>
          <v-flex
            xs12
            md2>
            <v-switch
              v-model="filters.all"
              :disabled="progessBar.loading"
              :label="`${ $t('All tanks') }` "
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(-7)"
              :date-label="getDateLabel('From')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="2"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(0)"
              :date-label="getDateLabel('To')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs6
            md2
            text-xs-left>
            <v-btn
              :disabled="!isValidationOk || progessBar.loading"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyFilter">
              {{ $t('Load') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs6
            md2
            text-xs-right>
            <MaglinkComponentCsvExportButton
              :is-validation-ok="isValidationOk"
              :loading="progessBar.loading"
              @csvExport="csvExport" />
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <MaglinkComponentLoadingBar
              :loading="progessBar.loading"
              :indeterminate="false"
              :max-value="progessBar.maxValue"
              :value="progessBar.currentValue" />
            <span>{{ itemCountLabel }}</span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="dataSource"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{backgroundColor: backColor(index, item) }"
                  class="text-xs-left">
                  <td class="text-xs-right">{{ item.tankNumber }}</td>
                  <td class="text-xs-right">{{ Maglink.GetCustomDateTime(item.initialTime, systemSettings.dateFormat) }}<br>{{ Maglink.GetCustomDateTime(item.finalTime, systemSettings.dateFormat) }}</td>
                  <td class="text-xs-right font-weight-bold"><br>{{ getDuration(item.initialTime, item.finalTime) }}</td>
                  <td class="text-xs-right">{{ item.initialProductVolume }}<br>{{ item.finalProductVolume }}</td>
                  <td class="text-xs-right font-weight-bold"><br>{{ Maglink.VolumeFormat(item.finalDeliveredVolume, systemSettings.volumeUnit) }}</td>
                  <td
                    :style="{display: 'none' }"
                    class="text-xs-right">{{ item.initialProductVolumeComp }}<br>{{ item.finalProductVolumeComp }}</td>
                  <td
                    :style="{display: 'none' }"
                    class="text-xs-right font-weight-bold"><br>{{ Maglink.VolumeFormat(item.finalDeliveredVolumeComp || 0, systemSettings.volumeUnit) }}</td>
                  <td class="text-xs-right">{{ item.initialWaterVolume }}<br>{{ item.finalWaterVolume }}</td>
                  <td class="text-xs-right font-weight-bold"><br>{{ Maglink.VolumeFormat(item.finalWaterVolume - item.initialWaterVolume, systemSettings.volumeUnit) }}</td>
                  <td class="text-xs-right">{{ Maglink.TemperatureFormat(Maglink.TemperatureToDisplay(item.initialTemperature, systemSettings.temperatureUnit)) }}<br>{{ Maglink.TemperatureFormat(Maglink.TemperatureToDisplay(item.finalTemperature, systemSettings.temperatureUnit)) }}</td>
                  <td class="text-xs-right font-weight-bold"><br>{{ Maglink.TemperatureFormat(Maglink.TemperatureToDisplay(item.finalTemperature, systemSettings.temperatureUnit) - Maglink.TemperatureToDisplay(item.initialTemperature, systemSettings.temperatureUnit)) }}</td>
                  <!-- <td class="text-xs-right"><br>{{ abortedMsg(item) }}</td> -->
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    progessBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    rules: {
      isDate: [ v => true ]
    },
    itemCountLabel: '',
    headers: [],
    dataSource: [],
    filters: {
      all: false,
      number: 1,
      fromDay: '',
      toDay: ''
    },
    volUdm: '',
    tempUdm: ''
  }),
  mounted () {
    var currentDate = new Date()
    this.filters.toDay = currentDate.toISOString().substr(0, 10)

    currentDate.setDate(currentDate.getDate() - 7)
    this.filters.fromDay = currentDate.toISOString().substr(0, 10)

    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc
    this.headers = [
      { sortable: false, text: this.$t('Tank'), align: 'right' },
      { sortable: false, text: this.$t('Start/End time'), align: 'right' },
      { sortable: false, text: this.$t('Duration'), align: 'right' }, // { sortable: false, text: this.$t('Duration ({0})', [this.$t('min')]), align: 'right' },
      { sortable: false, text: this.$t('Volume') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Delivered') + ' (' + this.volUdm + ')', align: 'right' },
      // { sortable: false, text: this.$t('TC volume') + ' (' + this.volUdm + ')', align: 'right' },
      // { sortable: false, text: this.$t('Delivered') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Water vol') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Water diff') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Temp') + ' (' + this.tempUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Diff') + ' (' + this.tempUdm + ')', align: 'right' }
      // { sortable: false, text: this.$t('Aborted'), align: 'right' }
    ]
  },
  methods: {
    getDuration (initial, final) {
      // return this.Maglink.RoundFormat((final - initial) / 60.0, 1)
      return this.Maglink.GetHourMinuteSecondFormat(initial, final)
    },
    abortedMsg (item) {
      if (item.aborted) return item.finalTankStatus

      return ''
    },
    applyFilter () {
      if (!this.onCheckDates()) return

      this.getDataSource()
    },
    backColor (index, item) {
      if (item.aborted) return '#ffdddd'

      return ((index % 2 === 0) ? '#cfdbfb' : 'transparent')
    },
    csvExport (sep) {
      let fileContent = ''
      let title = ''

      if (this.siteInfo.name) {
        fileContent += this.siteInfo.name + '\n'
      }
      if (this.siteInfo.header1) {
        fileContent += this.siteInfo.header1 + '\n'
      }
      if (this.siteInfo.header2) {
        fileContent += this.siteInfo.header2 + '\n'
      }
      if (this.siteInfo.header3) {
        fileContent += this.siteInfo.header3 + '\n'
      }

      // filter
      if (this.filters.all) {
        title = this.$t('All tanks')
        fileContent += title + '\n'
      } else {
        title = this.$t('Tank {0}', [ this.filters.number ])
        fileContent += title + sep
        fileContent += this.tanks[this.filters.number - 1].tankDescription + '\n'
      }
      fileContent += this.tanks[this.filters.number - 1].tankDescription + '\n'
      fileContent += this.$t('Date from') + sep
      fileContent += (this.filters.fromDay !== undefined ? this.filters.fromDay : '') + '\n'
      fileContent += this.$t('Date to') + sep
      fileContent += (this.filters.toDay !== undefined ? this.filters.toDay : '') + '\n'
      fileContent += '\n'

      this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
      this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc

      fileContent += this.$t('Tank') + sep
      fileContent += this.$t('Started') + sep
      fileContent += this.$t('Ended') + sep
      fileContent += this.$t('Duration') + ' (' + this.$t('min') + ')' + sep
      fileContent += this.$t('Initial volume') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Final volume') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Delivered') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Initial TC volume') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Final TC volume') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Delivered') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Initial water vol') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Final water vol') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Water diff') + ' (' + this.volUdm + ')' + sep
      fileContent += this.$t('Initial temp') + ' (' + this.tempUdm + ')' + sep
      fileContent += this.$t('Final temp') + ' (' + this.tempUdm + ')' + sep
      fileContent += this.$t('Diff') + ' (' + this.tempUdm + ')' + sep
      fileContent += this.$t('Aborted') + sep
      fileContent += '\n'

      for (let index = 0; index < this.dataSource.length; index++) {
        let t = this.dataSource[index]
        fileContent += t.tankNumber + sep
        fileContent += this.Maglink.GetCustomDateTime(t.initialTime, this.systemSettings.dateFormat) + sep
        fileContent += this.Maglink.GetCustomDateTime(t.finalTime, this.systemSettings.dateFormat) + sep
        fileContent += this.Maglink.RoundFormat((t.finalTime - t.initialTime) / 60.0, 1) + sep
        fileContent += t.initialProductVolume + sep
        fileContent += t.finalProductVolume + sep
        fileContent += this.Maglink.VolumeFormat(t.finalDeliveredVolume, this.systemSettings.volumeUnit) + sep
        fileContent += t.initialProductVolumeComp + sep
        fileContent += t.finalProductVolumeComp + sep
        fileContent += this.Maglink.VolumeFormat(t.finalDeliveredVolumeComp || 0, this.systemSettings.volumeUnit) + sep
        fileContent += t.initialWaterVolume + sep
        fileContent += t.finalWaterVolume + sep
        fileContent += this.Maglink.VolumeFormat(t.finalWaterVolume - t.initialWaterVolume, this.systemSettings.volumeUnit) + sep
        fileContent += this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(t.initialTemperature, this.systemSettings.temperatureUnit)) + sep
        fileContent += this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(t.finalTemperature, this.systemSettings.temperatureUnit)) + sep
        fileContent += this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(t.finalTemperature, this.systemSettings.temperatureUnit) - this.Maglink.TemperatureToDisplay(t.initialTemperature, this.systemSettings.temperatureUnit)) + sep + '\n'
        // fileContent += this.abortedMsg(t) + '\n'
      }

      let filename = this.$t('Delivery report') + '__' + title
      filename += '__' + (this.filters.fromDay !== undefined ? this.filters.fromDay : '')
      filename += '__' + (this.filters.toDay !== undefined ? this.filters.toDay : '')
      filename += '.csv'

      const link = this.Maglink.GetDownloadLinkCSV(fileContent, filename)
      document.body.appendChild(link)
      link.click()
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    getDataSource () {
      this.progessBar.loading = true
      this.dataSource = []

      this.Maglink.GetReportDeliveries(this.filters)
        .then(response => {
          this.progessBar.maxValue = response.data.length

          for (var i = 0; i < response.data.length; i++) {
            this.progessBar.currentValue = i
            this.dataSource.push(this.Maglink.ToDisplay(response.data[i], this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
          }
          this.progessBar.loading = false
          this.itemCountLabel = this.$t('Items: {0}', [ this.dataSource.length ])
        })
        .catch(error => {
          this.progessBar.loading = false
          this.snack('error', error.message)
        })
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.systemSettings.dateFormat + ')'
    },
    onCheckDates () {
      // no check if one date is missing
      if (this.filters.fromDay === undefined) return true
      if (this.filters.toDay === undefined) return true

      if (this.filters.fromDay > this.filters.toDay) {
        this.isValidationOk = false
        this.rules.isDate = [this.$t('Wrong date value')]
      } else {
        this.rules.isDate = [ v => true ]
        this.isValidationOk = true
        this.$refs.form.resetValidation()
      }

      return this.isValidationOk
    },
    onGetDate (componentKey, day) {
      if (componentKey === 1) {
        /*
        // go back for 3 years max
        if (day === undefined) {
          day = new Date()
          day.setDate(day.getDate() - (365 * 3))
          day = day.toISOString().substr(0, 10)
        }
        */

        this.filters.fromDay = day
      } else {
        /*
        // 'till tomorrow
        if (day === undefined) {
          day = new Date()
          day.setDate(day.getDate() + 1)
          day = day.toISOString().substr(0, 10)
        }
        */

        this.filters.toDay = day
      }

      this.onCheckDates()
    },
    snack (color, message) {
      message = this.$t('Deliveries') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
